<template>
    <div class="errorPage">
        <picture>
            <source v-bind:srcset="errorImage.webp" type="image/webp">
            <img
                class="errorPage-img"
                v-bind:src="errorImage.origin"
                alt=""
                aria-hidden="true"
            >
        </picture>
        <h2 class="errorPage-title">
            {{ i18n.t(msgTitle) }}
        </h2>
        <div class="errorPage-content">
            {{ i18n.t(msgContent) }}
        </div>
        <div v-if="isShowCta" class="errorPage-CTA">
            <button
                type="button"
                class="button _primary"
                v-on:click="$router.push({ name: RoutePage.Main })"
            >
                {{ i18n.t('errorPage_backToHomepage') }}
            </button>
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { RoutePage } from '@/interface/enum';
    import { getImage } from '@/libraries/helpers/imageHelper';
    import { i18n } from '@/libraries/i18n';

    export default defineComponent({
        name: 'ErrorPage',
        props: {
            msgType: {
                type: String,
                default() {
                    return 'error404';
                },
            },
            msgTitle: {
                type: String,
                default() {
                    return 'errorPage_notFound_title';
                },
            },
            msgContent: {
                type: String,
                default() {
                    return 'errorPage_notFound_content';
                },
            },
            isShowCta: {
                type: Boolean,
                default: true,
            },
        },
        setup(props) {
            const imageGlob = import.meta.glob('../assets/images/error/*.{png,webp}', {
                eager: true,
            });
            const errorImage = computed(() => getImage(imageGlob, `img_${props.msgType}`));

            return {
                errorImage,
                i18n,
                RoutePage,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/common/errorPage";
</style>
